import { tabletMatchMedia } from './utility';

export default function accordion() {
  const accordionTriggers = document.querySelectorAll('.js-accordion-trigger');

  const handleResize = () => {
    const isTablet = tabletMatchMedia.matches; // tablet以下かどうかを判定

    accordionTriggers.forEach((trigger) => {
      const parent = trigger.closest('.js-accordion');
      const innerContainer = parent.querySelector('.Navigation__inner');

      if (isTablet) {
        trigger.setAttribute('aria-expanded', 'false');
        innerContainer.setAttribute('inert', '');

        trigger.addEventListener('click', handleAccordion);
      } else {
        // PC表示時: アコーディオン無効化
        trigger.setAttribute('aria-expanded', 'true');
        innerContainer.removeAttribute('inert');

        // イベントリスナーを解除
        trigger.removeEventListener('click', handleAccordion);
      }
    });
  };

  const closeAllAccordions = () => {
    accordionTriggers.forEach((trigger) => {
      const parent = trigger.closest('.js-accordion');
      const innerContainer = parent?.querySelector('.Navigation__inner');
      if (parent && innerContainer) {
        trigger.setAttribute('aria-expanded', 'false');
        innerContainer.setAttribute('inert', '');
      }
    });
  };

  const handleAccordion = (e) => {
    e.preventDefault();

    const trigger = e.currentTarget;
    const parent = trigger.closest('.js-accordion');
    const innerContainer = parent.querySelector('.Navigation__inner');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    // トグル処理
    trigger.setAttribute('aria-expanded', !isExpanded);
    innerContainer.toggleAttribute('inert', isExpanded);
  };

  // リサイズ監視と初期化処理
  const attachResizeListener = () => {
    handleResize(); // 初期化時に一度実行

    // メディアクエリの変更を監視し動作を切り替え
    tabletMatchMedia.addEventListener('change', handleResize);
  };

  const cleanup = () => {
    tabletMatchMedia.removeEventListener('change', handleResize);
    document.removeEventListener('closeAccordions', closeAllAccordions);
    accordionTriggers.forEach((trigger) => {
      trigger.removeEventListener('click', handleAccordion);
    });
  };

  document.addEventListener('closeAccordions', closeAllAccordions);

  attachResizeListener();
}
